import { Form, Button, Divider, Spin } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { ENDPOINTS } from '../../../config/EndPoints'
import { Functions } from '../../../config/Functions'
import { Language } from '../../../config/Language'
import { ADVERTISERS_DETAIL } from '../../../config/Path'
import { useAxios } from '../../../hooks/useAxios'
import useCountryContext from '../../../hooks/useCountryContext'
import { ICountries } from '../../../interface/ICountries'
import { CustomInput } from '../../common/custom-input/CustomInput'
import { CustomSelect } from '../../common/custom-select/CustomSelect'
import { CustomUploader } from '../../common/custom-uploader/CustomUploader'
import { Notifications } from '../../common/notifications/Notifications'
import { ShowImage } from '../../common/show-img/ShowImage'
import { antIcon } from '../../common/spin-icon/SpinIcon'

interface IProps {
    next: () => void
    setGlobalData: (formValue: {}) => void
    globalData: any
}
interface FormValue {
    contactName: string
    contactLastName: string
    email: string
    mobile: string
    contactType: number
    countryId: number
}

export const ContactForm = ({ ...props }: IProps) => {
    const { next, setGlobalData, globalData } = props
    const [form] = Form.useForm()
    const history = useHistory()
    const { country } = useCountryContext()
    const { getTranslation } = Language()
    const [contactType, setContactType] = useState([])
    const [contactTypeSpin, setContactTypeSpin] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const [confirmSpin, setConfirmSpin] = useState(false)
    const [formValue, setFormValue] = useState<FormValue>()
    const { successObject, errorObjectWithData } = Notifications()
    const { get, post } = useAxios()

    useEffect(() => {
        loadContactType()
        return () => {}
    }, [])

    const loadContactType = () => {
        setContactTypeSpin(true)
        get(
            ENDPOINTS.GET_CONTACT_TYPES,
            {},
            successContactType,
            error,
            alwaysContactType,
        )
    }

    const successContactType = useCallback((response: any) => {
        setContactTypeSpin(false)
        let result: any = response.data.data
        result = result.filter((item: any) => item.id !== 3)
        let dataResponse = result.reduce(
            (acc: any, item: any) => [
                ...acc,
                {
                    label: item.label || item.name || item.full_name,
                    value: item.id || item.value,
                },
            ],
            [],
        )
        setContactType(dataResponse)
    }, [])

    const alwaysContactType = () => {
        setContactTypeSpin(false)
    }

    const onChange = (values: any) => {
        let newFormValue: FormValue = { ...formValue, ...values }
        setFormValue(newFormValue)
    }

    const getValues = () => {
        let result: any = {
            name: formValue?.contactName,
            last_name: formValue?.contactLastName,
            email: formValue?.email,
            country_id: formValue?.countryId,
            contact_type_id: formValue?.contactType,
            brand_id: globalData.brandId,
        }
        if (formValue?.mobile) result.mobile = formValue?.mobile
        return result
    }

    const onSave = (values: any) => {
        setShowConfirm(true)
    }

    const onConfirm = (values: any) => {
        setConfirmSpin(true)
        let result = getValues()
        post(
            ENDPOINTS.POST_ACCOUNT_CONTACT.replace(
                '{account}',
                globalData.advertiserId,
            ),
            result,
            successSave,
            error,
            alwaysSave,
        )
    }

    const error = (errors: any) => {
        errorObjectWithData(errors)
    }

    const successSave = (response: any) => {
        setConfirmSpin(false)
        successObject(response)
        goToDetail()
    }

    const goToDetail = () => {
        history.push(`${ADVERTISERS_DETAIL}/${globalData.advertiserId}`)
    }

    const alwaysSave = () => {
        setConfirmSpin(false)
    }

    const handleBack = () => {
        setShowConfirm(false)
    }

    let countriesList: ICountries[] =
        country && Functions.getCountriesByLanguage(country)

    return (
        <>
            <Spin
                className='spin-local'
                indicator={antIcon}
                spinning={confirmSpin}>
                {!showConfirm && (
                    <Form
                        className='form-advertiser'
                        form={form}
                        layout='vertical'
                        scrollToFirstError
                        onValuesChange={onChange}
                        onFinish={onSave}
                        size='large'>
                        <div className='form-container'>
                            <div className='form-body'>
                                <CustomInput
                                    name='contactName'
                                    id='contactName'
                                    label={getTranslation('nombre')}
                                    required={true}
                                />
                                <CustomInput
                                    name='contactLastName'
                                    id='contactLastName'
                                    label={getTranslation('apellido')}
                                    required={true}
                                />

                                <CustomInput
                                    name='email'
                                    id='email'
                                    type='email'
                                    label={getTranslation('email')}
                                    required={true}
                                />

                                <CustomInput
                                    name='mobile'
                                    id='mobile'
                                    label={getTranslation('phone')}
                                />

                                <CustomSelect
                                    label={getTranslation('tipo_de_contacto')}
                                    name='contactType'
                                    id='contactType'
                                    data={contactType}
                                    value={formValue?.contactType}
                                    required={true}
                                />

                                <CustomSelect
                                    label={getTranslation('pais')}
                                    name='countryId'
                                    id='countryId'
                                    data={countriesList}
                                    value={formValue?.countryId}
                                    required={true}
                                />
                            </div>
                            <div className='footer-text'>
                                {getTranslation('you_will_create_contacts_end')}
                            </div>
                            <div className='buttons-footer'>
                                <>
                                    <Button
                                        style={{ margin: '0 8px' }}
                                        ghost
                                        type='primary'
                                        size='small'
                                        onClick={goToDetail}>
                                        {getTranslation('skip_this_step')}
                                    </Button>

                                    <Button
                                        type='primary'
                                        size='small'
                                        htmlType='submit'>
                                        {getTranslation('guardar')}
                                    </Button>
                                </>
                            </div>
                        </div>
                    </Form>
                )}
                {showConfirm && (
                    <div className='confirmation-advertiser'>
                        <div className='confirmation-data'>
                            <div className='title-description'>
                                <div className='title'>
                                    {getTranslation('nombre')}
                                </div>
                                <div className='description'>
                                    {formValue?.contactName}
                                </div>
                            </div>
                            <div className='title-description'>
                                <div className='title'>
                                    {getTranslation('apellido')}
                                </div>
                                <div className='description'>
                                    {formValue?.contactLastName}
                                </div>
                            </div>
                            <div className='title-description'>
                                <div className='title'>
                                    {getTranslation('email')}
                                </div>
                                <div className='description'>
                                    {formValue?.email}
                                </div>
                            </div>
                            <div className='title-description'>
                                <div className='title'>
                                    {getTranslation('phone')}
                                </div>
                                <div className='description'>
                                    {formValue?.mobile}
                                </div>
                            </div>
                            <div className='title-description'>
                                <div className='title'>
                                    {getTranslation('tipo_de_contacto')}
                                </div>
                                <div className='description'>
                                    {contactType.map((item: any) => {
                                        if (
                                            item.value ===
                                            formValue?.contactType
                                        )
                                            return item.label
                                    })}
                                </div>
                            </div>
                            <div className='title-description'>
                                <div className='title'>
                                    {getTranslation('pais')}
                                </div>
                                <div className='description'>
                                    {countriesList.map((item: any) => {
                                        if (item.value === formValue?.countryId)
                                            return item.label
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className='buttons-footer'>
                            <>
                                <Button
                                    style={{ margin: '0 8px' }}
                                    ghost
                                    type='primary'
                                    size='small'
                                    onClick={goToDetail}>
                                    {getTranslation('skip_this_step')}
                                </Button>
                                <Divider
                                    type='vertical'
                                    style={{
                                        borderColor: '#E8E8E8',
                                        height: '1.5em',
                                    }}
                                />
                                <Button
                                    style={{ margin: '0 8px' }}
                                    ghost
                                    type='primary'
                                    size='small'
                                    onClick={handleBack}>
                                    {getTranslation('volver')}
                                </Button>

                                <Button
                                    type='primary'
                                    size='small'
                                    onClick={onConfirm}>
                                    {getTranslation('finish')}
                                </Button>
                            </>
                        </div>
                    </div>
                )}
            </Spin>
        </>
    )
}
